import Model from '../../models/Model';
import { ArgTypes } from '../../utils/ArgValidation';

const ChangedTransformsMessage = Model({
  smRecipeId: { type: ArgTypes.number }, // SM (not recs) recipe
});

export default ChangedTransformsMessage;
